import { motion } from "framer-motion";
import BuggyBucks from "./BuggyBucks";

export default function BugInfo({ bug }) {
  const { name, caption, funFact, bugginess } = bug || {};
  return (
    <div>
      <div className="flex flex-col items-center">
        {/* Pop-in for the name */}

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, type: "spring" }}
        >
          <h1 className="text-2xl font-bold text-center p-2">{name}</h1>
          <h3 className="italic text-pink-600 text-center">{caption}</h3>
        </motion.div>
      </div>

      <div className="mx-10">
        {/* Slide-in Fun Fact header */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.4 }}
          className="m-3"
        >
          <h4 className="mb-2 font-semibold">fun fact:</h4>
          <p>{funFact}</p>
        </motion.div>

        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.4 }}
          className="m-3"
        >
          <h4 className="mb-2 font-semibold">bugginess rating:</h4>
          <p>{bugginess}</p>
        </motion.div>
      </div>

      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.6, duration: 0.6, type: "spring" }}
        className="mt-6 flex justify-center text-purple-600 text-center"
      >
        <BuggyBucks bug={bug} />
      </motion.div>

      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.6, duration: 0.6, type: "spring" }}
        className="mt-6 text-purple-600 font-semibold text-center"
      >
        <p>come back tomorrow for a new bug!</p>
      </motion.div>
    </div>
  );
}
